import { Grid2, Typography } from "@mui/material";
import ExpandableTypography from "./ExpandableTypography";

const DocumentationDetail = ({ formData, fromReview = false }) => {
    return (
        <>
            <Typography variant="h4" color="default.main">
                Documentation
            </Typography>
            {!fromReview && (
                <Typography variant="body1" color="default.light">
                    Upload or confirm documentation related to client’s care
                </Typography>
            )}
            <Grid2 container spacing={3} mt={3}>
                <Grid2 size={{ xs: 12, sm: 6 }}>
                    <Typography variant="body2" color="default.main" mb={0.5}>
                        Medical Power of Attorney (MPOA)
                    </Typography>
                    <Typography variant="body1" color="default.light">
                        {formData?.documentationSection0?.documentMPOA
                            ? "Yes"
                            : "No"}
                    </Typography>
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 6 }}>
                    <Typography variant="body2" color="default.main" mb={0.5}>
                        OOH DNR (Do Not Resuscitate)
                    </Typography>
                    <Typography variant="body1" color="default.light">
                        {formData?.documentationSection0?.documentDNR
                            ? "Yes"
                            : "No"}
                    </Typography>
                </Grid2>
                {formData?.documentationSection0?.documentDNR === true && (
                    <Grid2 size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2" color="default.main" mb={0.5}>
                            Enter Location of Document
                        </Typography>
                        <Typography variant="body1" color="default.light">
                            {formData?.documentationSection0?.dnrLocation
                                ? formData.documentationSection0.dnrLocation
                                : "-"}
                        </Typography>
                    </Grid2>
                )}
            </Grid2>
        </>
    );
};
export default DocumentationDetail;